export default class InvoiceLineMinified {
  constructor(
    public days: number,
    public price: number,
    public guests: number
  ) {}
}
